export default [
    {
        path: '/suppliers',
        name: 'Company / Suppliers',
        component: () => import('@/views/pages/suppliers'),
        meta:
        {
            page: 'list',
        },
        children:
        [
            {
                path: 'overview',
                name: 'Company / Supplier Overview',
                component: () => import('@/views/pages/suppliers'),
                meta:
                {
                    page: 'overview',
                    subPage: 'main',
                },
            },
            {
                path: ':code',
                name: 'Company / View Supplier',
                component: () => import('@/views/pages/suppliers'),
                meta:
                {
                    page: 'view',
                },
            },
        ],
    },
];